import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";

export default class SignUpService extends AbstractService {
	static endpoint = ENDPOINTS.signUp;

	static signUpLEA(data) {
		return this.post({
			endpoint: `${this.endpoint}/${ENDPOINTS.lea}`,
			data,
		});
	}

	static saveDirectDepositAccount(queryParams, data) {
		return this.post({
			endpoint: `${this.endpoint}/${ENDPOINTS.payments}/`,
			queryParams,
			data,
		});
	}

	static saveJurisdictionFees(queryParams, data) {
		return this.post({
			endpoint: `${this.endpoint}/${ENDPOINTS.lea}/fees`,
			queryParams,
			data,
		});
	}

	static saveAgencyRules(queryParams, data) {
		return this.post({
			endpoint: `${this.endpoint}/${ENDPOINTS.lea}/agencyrules`,
			queryParams,
			data,
		});
	}

	static saveOfficerRules(queryParams, data) {
		return this.post({
			endpoint: `${this.endpoint}/${ENDPOINTS.lea}/officerrules`,
			queryParams,
			data,
		});
	}

	static signUpCoordinator(queryParams, data) {
		return this.post({
			endpoint: `${this.endpoint}/${ENDPOINTS.coordinator}`,
			queryParams,
			data,
		});
	}

	static saveCoordinatorDetails(queryParams, data) {
		return this.post({
			endpoint: `${this.endpoint}/${ENDPOINTS.coordinator}/details`,
			queryParams,
			data,
		});
	}

	static getInvitedByUserDetails(token) {
		return this.get({
			endpoint: `${ENDPOINTS.accounts}/anonymous/${token}`,
		});
	}
}
